module.exports = __webpack_public_path__ + "static/media/wmsui32_3938.ed4eb91c.ico";